import PageHero from "@/components/feature/PageHero";
import Accordion from "@/components/base/Accordion";
import CtaSection from "@/components/feature/CtaSection";
import { faqs } from "@/mocks/public";

export default function FaqPage() {
  return (
    <div className="flex flex-col">
      <PageHero
        eyebrow="FAQ"
        current="FAQ"
        title="Questions fréquentes"
        description="Tout ce qu'il faut savoir sur la plateforme, les profils utilisateurs, les formules et la gestion au quotidien."
      />

      <section className="py-14 md:py-20 bg-background-50">
        <div className="container-page">
          <div className="mx-auto max-w-3xl">
            <Accordion items={faqs} defaultOpen={0} />
          </div>
        </div>
      </section>

      <CtaSection
        title="Vous ne trouvez pas votre réponse ?"
        description="Notre équipe vous accompagne pour choisir la formule et configurer votre espace."
        primaryLabel="Contacter l'équipe"
        primaryTo="/contact"
        secondaryLabel="Voir les tarifs"
        secondaryTo="/tarifs"
      />
    </div>
  );
}